import { ClickListener } from '../../../../../lib/web/components/click-listener';
import { Component } from '../../../../../lib/web/components/component';
import { ModalComponent } from '../../../../../lib/web/components/modal.component';

@Component({
    selector: '.m-change-password-confirm',
})
export class ChangePasswordConfirmComponent extends ModalComponent<HTMLInputElement> {

    public constructor(node: HTMLInputElement) {
        super(node);
    }    

    public onInit(): void {
        super.onInit();
    }

    @ClickListener('.m-change-password-confirm__close')
    public onClose(): void {
        this.close();
    }
}